export const warehouseTypes = [
  'snowflake',
  'databricks',
  'bigquery',
  'redshift',
] as const;

export type WarehouseType = (typeof warehouseTypes)[number];
export type WarehouseTypeOrUnknown = WarehouseType | 'unknown';

export function getWarehouseType<
  TDefaultValue extends undefined | WarehouseType | 'unknown',
>(
  warehouseName: string | undefined,
  defaultValue?: TDefaultValue,
): WarehouseType | TDefaultValue {
  const input = warehouseName?.toLowerCase();
  const index = warehouseTypes.findIndex((item) => item === input);
  return warehouseTypes[index] || defaultValue;
}

export const warehouseNameMap: Record<WarehouseTypeOrUnknown, string> = {
  snowflake: 'Snowflake',
  databricks: 'Databricks',
  bigquery: 'BigQuery',
  redshift: 'Redshift',
  unknown: 'Unknown',
};
